import { render, staticRenderFns } from "./termsTiger.vue?vue&type=template&id=617b6cee&scoped=true"
import script from "./termsTiger.vue?vue&type=script&lang=js"
export * from "./termsTiger.vue?vue&type=script&lang=js"
import style0 from "./termsTiger.vue?vue&type=style&index=0&id=617b6cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b6cee",
  null
  
)

export default component.exports